import React, { useState } from 'react'
import QuestionCards from './QuestionCards'
import { fetchQuizQuestions } from '../API'
import { QuestionState } from '../API'
import { Wrapper, GlobalStyle } from '../styles/App.styles'

export type AnswerObject = {
  question: string
  answer: string
  correctGuess: boolean
  correctAnswer: string
}

const TOTAL_QUESTIONS = 10

const Home = () => {
  const [loading, setLoading] = useState(false)
  const [questions, setQuestions] = useState<QuestionState[]>([])
  const [number, setNumber] = useState(0)
  const [userAnswers, setUserAnswers] = useState<AnswerObject[]>([])
  const [score, setScore] = useState(0)
  const [gameOver, setGameOver] = useState(true)
  const [level, setlevel] = useState('easy')

  const startTrivia = async () => {
    const newQuestions = await fetchQuizQuestions(TOTAL_QUESTIONS, level)
    setLoading(true)
    setGameOver(false)
    setQuestions(newQuestions)
    setScore(0)
    setUserAnswers([])
    setNumber(0)
    setLoading(false)
  }

  const checkAnswer = (e: React.MouseEvent<HTMLButtonElement>) => {
    const answer = e.currentTarget.value
    const correctGuess = questions[number].correct_answer === answer
    if (correctGuess) setScore(prev => prev + 1)

    const answerObject = {
      question: questions[number].question,
      answer,
      correctGuess,
      correctAnswer: questions[number].correct_answer
    }

    setUserAnswers(prev => [...prev, answerObject])
  }

  const nextQuestion = () => {
    const nextQuestion = number + 1
    if (nextQuestion === TOTAL_QUESTIONS) {
      setGameOver(true)
    } else {
      setNumber(nextQuestion)
    }

  }

  const choosenLevel = (e: React.MouseEvent<HTMLButtonElement>) => {
    setlevel(e.currentTarget.value)
  }
  
  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <h1>Quiz</h1>
        {gameOver && userAnswers.length !== TOTAL_QUESTIONS ?
          (
            <div>
              <button className='start' onClick={startTrivia}>
                Start
              </button>
              <Wrapper>
                <button onClick={choosenLevel} className='level' value='easy'>EASY</button>
                <button onClick={choosenLevel} className='level' value='medium'>MEDIUM</button>
                <button onClick={choosenLevel} className='level' value='hard'>HARD</button>
                <p className="instruction">Choose a level and hit start</p>
              </Wrapper>
            </div>
          ) : null}
        {userAnswers.length === TOTAL_QUESTIONS &&
          (<div>
            <p>Your Total Score is {score}. Try Again</p>
            <button className='start' onClick={startTrivia}>
              Re-Start
              </button>
          </div>)
        }
        {!gameOver && <p className='score'>Score: {score} </p>}
        {loading ? <p>Loading...</p> : null}
        {!loading && !gameOver && userAnswers.length !== TOTAL_QUESTIONS ?
          <QuestionCards
            questionNumber={number + 1}
            totalQuestions={TOTAL_QUESTIONS}
            question={questions[number].question}
            answers={questions[number].answers}
            userAnswer={userAnswers ? userAnswers[number] : undefined}
            callback={checkAnswer}
          />
          : null
        }
        {!gameOver && !loading && userAnswers.length === number + 1 && number !== TOTAL_QUESTIONS - 1 ?
          <button className='next' onClick={nextQuestion}>
            Next Question
      </button> : null
        }
      </Wrapper>
    </>
  )
}

export default Home